export default {
  namespaced: true,
  state: {
    disableTracking: false,
    heatMap: [],
    heatMapRange: [],
    playbackId: '',
    playbackIndex: 0,
    playbackTimestamp: 0,
    playbackPercentage: 0,
    sessionId: '',
    sessionPlayback: {},
    showHeat: false,
    showPlayback: false
  },

  mutations: {
    SET_DISABLE_TRACKING (state, isDisabled) {
      state.disableTracking = isDisabled
    },

    SET_SESSION_ID (state, id) {
      state.sessionId = id
    },

    SET_HEAT_MAP (state, heatMap) {
      state.heatMap = heatMap
    },

    SET_HEAT_MAP_RANGE (state, { start, end }) {
      state.heatMapRange.push(start)
      state.heatMapRange.push(end)
    },

    SET_SESSION_PLAYBACK (state, sessionPlayback) {
      state.sessionPlayback = sessionPlayback
    },

    SET_SHOW_HEAT (state, isActive) {
      state.showHeat = isActive
    },

    SET_SHOW_PLAYBACK (state, isActive) {
      state.showPlayback = isActive
    },

    SET_PLAYBACK_ID (state, id) {
      state.playbackId = id
    },

    UPDATE_PLAYBACK_INDEX (state, timestamp) {
      state.playbackIndex++
      state.playbackTimestamp = timestamp
    },

    UPDATE_PLAYBACK_PERCENTAGE (state, percentage) {
      state.playbackPercentage = percentage
    },
  },

  getters: {
    disableTracking: (state) => {
      return state.disableTracking
    },

    sessionId: (state) => {
      return state.sessionId
    },

    sessionPlayback: (state) => {
      return state.sessionPlayback
    },

    heatMap: (state) => {
      return state.heatMap
    },

    heatMapRange: (state) => {
      return state.heatMapRange
    },

    playbackId: (state) => {
      return state.playbackId
    },

    playbackIndex: (state) => {
      return state.playbackIndex
    },

    playbackPercentage: (state) => {
      return state.playbackPercentage
    },

    showHeat: (state) => {
      return state.showHeat
    },

    showPlayback: (state) => {
      return state.showPlayback
    }
  }
}
